import React from 'react'
import NewHeader from '../Layout/NewHeader'
import NewSidebar from '../Layout/NewSidebar'

function BankInfoCom() {
  return (
    <div>
    <NewHeader />
    <NewSidebar />
    <div className="main" style={{
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      minHeight: "100vh",
      paddingTop: "50px"
    }}>
      <div className="my">
        <div className="container mt-5 pt-5 mb-5 pb-5">
          
          {/* Heading */}
          <h2 style={{
            textAlign: "center",
            color: "#fff",
            marginBottom: "30px",
            fontWeight: "700",
            fontSize: "32px",
            animation: "fadeInDown 1s"
          }}>
            User KYC Verification
          </h2>
  
          {/* KYC Form */}
          <div className="kyc-form">
            <form>
              {/* Personal Information */}
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label htmlFor="name" style={{ color: "#fff" }}>Full Name</label>
                    <input type="text" className="form-control" id="name" placeholder="Enter Full Name" />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label htmlFor="dob" style={{ color: "#fff" }}>Date of Birth</label>
                    <input type="date" className="form-control" id="dob" />
                  </div>
                </div>
              </div>
  
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label htmlFor="gender" style={{ color: "#fff" }}>Gender</label>
                    <select className="form-control" id="gender">
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label htmlFor="email" style={{ color: "#fff" }}>Email Address</label>
                    <input type="email" className="form-control" id="email" placeholder="Enter Email" />
                  </div>
                </div>
              </div>
  
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label htmlFor="phone" style={{ color: "#fff" }}>Phone Number</label>
                    <input type="tel" className="form-control" id="phone" placeholder="Enter Phone Number" />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label htmlFor="aadhar" style={{ color: "#fff" }}>Aadhar Number</label>
                    <input type="text" className="form-control" id="aadhar" placeholder="Enter Aadhar Number" />
                  </div>
                </div>
              </div>
  
              {/* Address Details */}
              <div className="form-group">
                <label htmlFor="address" style={{ color: "#fff" }}>Address</label>
                <textarea className="form-control" id="address" placeholder="Enter Address" rows="4"></textarea>
              </div>
  
              {/* Bank Details */}
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label htmlFor="accountNumber" style={{ color: "#fff" }}>Bank Account Number</label>
                    <input type="text" className="form-control" id="accountNumber" placeholder="Enter Bank Account Number" />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label htmlFor="ifsc" style={{ color: "#fff" }}>Bank IFSC Code</label>
                    <input type="text" className="form-control" id="ifsc" placeholder="Enter Bank IFSC Code" />
                  </div>
                </div>
              </div>
  
              {/* Document Upload */}
              <div className="form-group">
                <label htmlFor="document" style={{ color: "#fff" }}>Upload KYC Document (Aadhar/Passport)</label>
                <input type="file" className="form-control-file" id="document" />
              </div>
  
              {/* Submit Button */}
              <button type="submit" className="btn btn-primary btn-block" style={{
                backgroundColor: "#4c51bf", 
                borderColor: "#4c51bf", 
                color: "#fff", 
                fontWeight: "bold",
                fontSize: "16px"
              }}>
                Submit KYC
              </button>
            </form>
          </div>
  
        </div>
  
        {/* STYLE TAG */}
        <style jsx="true">{`
          .kyc-form {
            background: #fff;
            padding: 30px;
            border-radius: 8px;
            box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
          }
          .form-control {
            border-radius: 8px;
            padding: 12px;
            margin-bottom: 20px;
          }
          .form-control-file {
            border-radius: 8px;
            padding: 10px;
          }
          .btn {
            padding: 12px;
            border-radius: 8px;
            font-size: 16px;
            transition: background-color 0.3s;
          }
          .btn:hover {
            background-color: #3e44a7;
          }
  
          @keyframes fadeInDown {
            0% {
              opacity: 0;
              transform: translateY(-20px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
  
          @media (max-width: 768px) {
            .kyc-form {
              padding: 20px;
            }
          }
        `}</style>
  
      </div>
    </div>
  </div>
  
  )
}

export default BankInfoCom
